module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/1_9ca99409a5fa731f72b85f58310a7ef6.png";